import React from "react";
import { myStoryData } from "../utils";
import { TimelineSlider } from "../../../components/TimelineSlider";

export const MyStory: React.FC = () => {
  return (
    <section
      className="section-container padding-top-4 padding-bottom-4"
      id="my_story_section"
    >
      <div className="site-content-wrap" id="my_story_container">
        <h2 className="section-title text-center">My Story</h2>

        <TimelineSlider list={myStoryData} />
      </div>
    </section>
  );
};
